import { Injectable, DestroyRef, inject } from '@angular/core';
import { Subject, Observable, BehaviorSubject, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Order } from 'src/app/models/order.model'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  private ordersSubject: Subject<Array<Order>>;
  public ordersObservable: Observable<Array<Order>>;
  orders: Array<Order>;

  private destroyRef = inject(DestroyRef);
  private http = inject(HttpClient);

  constructor() {
    this.orders = []
    this.ordersSubject = new BehaviorSubject<Array<Order>>(this.orders);
    this.ordersObservable = this.ordersSubject.asObservable();
  }

  public setOrders(newOrders: Array<Order>)
  {
    this.orders = newOrders;
    this.ordersSubject.next(newOrders);
  }

  public getOrders()
  {
    this.http.get(environment.apiURL + '/services/orders/get-orders', { observe: 'response', withCredentials: true })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (response) => {
          const orders = response.body as Array<Order>
          this.setOrders(orders);
        },
        (_error) => {
          this.setOrders([]);
        })
  }

  saveOrder(sessionId: string) {
    return this.http.post(environment.apiURL + '/services/orders/create-order', {session_id: sessionId}, {withCredentials: true})
      .pipe(tap(
        (order) => {
          this.orders.push(<Order>order);
          this.ordersSubject.next(this.orders);
        }))
  }
}
